import type { FaireProductEntity } from "../../entity_types/product";

export const p_n52gu9hsut: FaireProductEntity = {
  token: "p_n52gu9hsut",
  type: "product",
  name: "Smudge Spray - Soul Sticks Palo Santo (3.5 oz)",
  brandToken: "b_89kf2nlsjr",
  brandName: "Designs by Deekay Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/ae3f4f526f3f2f67053e66d0718e22c966c9aea365ce5993dc7417ae65cd5c24.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.58,
  description:
    "Smudge Spray - Soul Sticks Palo Santo (3.5 oz)\n \n PRODUCT SPECS\n • Size: 3.5 oz.\n • Format: Smudge spray\n • Ingredients: Purified water, palo santo wood, quartz crystals, and essential oils\n • Packaging: Retail box included\n • Scent/Profile: Palo Santo\n \n RETAIL PERFORMANCE\n • Spray format offers a practical smoke-free option in cleansing assortments\n • Retail box supports stronger shelf presentation and gifting\n • Palo Santo theme has broad appeal across spiritual and wellness retail\n • Easy cross-merchandise with candles, incense, and sprays\n • Compact size supports register, shelf, and travel-friendly merchandising",
  tags: [],
  msrpDollars: 13.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:19.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
